import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import style from './HospitalInformation.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import {useNavigate} from 'react-router-dom';
import URL from '../../../../../constants/url';
import hospitalInformLink01 from "../../../../../images/user/i_3d_hospital_inform_link_01.svg";
import hospitalInformLink02 from "../../../../../images/user/i_3d_hospital_inform_link_02.svg";
import hospitalInformLink03 from "../../../../../images/user/i_3d_hospital_inform_link_03.svg";

const HospitalInformation = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { hsptlCd } = location.state || {};
    
    
    return (
        <>
            <HeadSub title="병원 정보" />

            <div id="sub-content" data-layout="white">     
                <div className='inner-wrap'>
                 
                    <div className={style['inform-lists-box']}>
                        <ul>
                            <li>
                                <div 
                                    className={style['inner-box']} 
                                    onClick={()=> navigate(URL.HOSPITAL_DEPARTMENTINFORM, {
                                        state: {
                                            hospitCd: hsptlCd
                                        }
                                    }
                                )}>
                                    <div className={style['img-box']} data-img="1">
                                        <object data={hospitalInformLink01} className='animation-3' aria-hidden='true'></object>
                                    </div>
                                    <div className={style['txt-box']}>
                                        <p>진료과/의료진 안내</p>
                                        <span>진료과별 의료진 정보를 확인하고, <br />
                                        전문의를 찾아보세요.</span>
                                    </div>
                                </div>
                            </li>

                            {hsptlCd !== "016" && (  // 인천 제외 
                            <li>
                                <div 
                                    className={style['inner-box']} 
                                    onClick={()=> navigate(URL.HOSPITAL_LOCATIONINFO, {
                                        state: {
                                            hospitCd: hsptlCd
                                        }}
                                    )}>
                                    <div className={style['img-box']} data-img="2">
                                        <object data={hospitalInformLink02} className='animation-3' aria-hidden='true'></object>
                                    </div>
                                    <div className={style['txt-box']}>
                                        <p>진료실/검사실 위치 안내</p>
                                        <span>진료 및 검사가 이루어지는 장소의 위치를 <br />
                                        한눈에 확인하세요.</span>
                                    </div>
                                </div>
                            </li>
                            )}

                            <li>
                                <div 
                                    className={style['inner-box']} 
                                    onClick={()=> navigate(URL.HOSPITAL_PHONENUMINFO, {
                                        state: {
                                            hospitCd: hsptlCd
                                        }}
                                    )}>
                                    <div className={style['img-box']} data-img="3">
                                        <object data={hospitalInformLink03} className='animation-3' aria-hidden='true'></object>
                                    </div>
                                    <div className={style['txt-box']}>
                                        <p>주요 전화번호 안내</p>
                                        <span>병원 이용과 관련된 주요 전화번호를 확인하고, <br />
                                        필요한 문의를 빠르게 해결하세요.</span>
                                    </div>
                                    
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </>
    );
};

export default HospitalInformation;
